import { inject, Injectable } from '@angular/core';
import { Device, Call } from '@twilio/voice-sdk';
import { ToasterMessageService } from '../../../../core/services/topbar-toaster/toaster-message.service';
import { CookieService } from 'ngx-cookie-service';
import { session } from '../../../../core/common/session/session';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { catchError, tap, throwError } from 'rxjs';
import { LoaderService } from '../../../../core/services/loader/loader.service';
import { CommonHttpsService } from '../../../../core/services/https/common-https.service';
import { apiUrls } from '../../../../core/common/api_urls/api_urls';
import { headers } from '../../../../core/common/headers';

@Injectable({
  providedIn: 'root',
})
export class TwilioMakeACallService {
  private device?: Device;
  cookiesService = inject(CookieService);

  constructor(
    public messageService: ToasterMessageService,
    private http: HttpClient,
    public loadingService: LoaderService,
    public commonHttpService: CommonHttpsService,
  ) {}

  getAllClinicNumbers() {
    const header = new HttpHeaders({ [headers.lookupHeader]: 'true' });
    return this.commonHttpService
      .GetListwHead(apiUrls.authentication.getAllClinicNumbers, { headers: header })
      .pipe(
        catchError((error) => throwError(() => error)),
      );
  }

  getToken() {
    // localStorage.setItem('deviceRegistered', 'false');

    const identity = 'noreply@caregenix.solutions';

    let authToken = this.cookiesService.get(session.authToken);
    let user;
    const userSettingsString = localStorage.getItem('userSettings');
    if (userSettingsString) {
      const userSettings = JSON.parse(userSettingsString);
      user = userSettings?.userInfo || {};
    }

    const detail = `1234567890/1/1/${user.id}/notavailable`;
    let HEADER;

    if (authToken) {
      HEADER = {
        'X-Token': authToken,
        'X-Username': user?.username,
      };
    }

    return this.http
      .post<{
        token: string;
        cognitoUserId: string;
      }>(
        `${environment.twilioUrl}/api/generate-token`,
        { detail: detail },
        {
          headers: HEADER,
        },
      )
      .pipe(
        tap((data) => {
          console.log(data);
          // localStorage.setItem('cognitoID', data.cognitoUserId);
          localStorage.setItem('cognitoID', data.cognitoUserId);
        }),
        catchError((error: any) => {
          localStorage.setItem('deviceRegistered', 'false');
          this.loadingService.stopSpinner();
          return throwError(() => error);
        }),
      );
  }

  initialize(token: any) {
    try {
      console.log('Creating Twilio Device...');
      this.device = new Device(token);

      this.device.on('registering', () => {
        console.log('ℹ️ Registering Twilio Device...');
      });

      this.device.register();

      console.log(this.device);

      this.device.on('registered', () => {
        console.log('✅ Twilio Device registered');
        localStorage.setItem('deviceRegistered', 'true');
        // this.messageService.successMessage('Twilio Device registered', true);
      });

      this.device.on('error', (error: any) => {
        console.error('❌ Twilio Device error:', error);
        localStorage.setItem('deviceRegistered', 'false');
        // this.messageService.errroMessage('Twilio Device error', true);
      });

      // this.device.on('incoming', (call) => {
      //   console.log('📞 Incoming call');
      //   call.accept();
      // });

      this.device.on('ready', () => {
        console.log('✅ Twilio Device ready for calls');
        localStorage.setItem('deviceRegistered', 'true');
        // this.messageService.successMessage(
        //   '✅ Twilio Device ready for calls',
        //   true,
        // );
      });
    } catch (error) {
      console.error('🚫 Failed to initialize Twilio Device:', error);
      localStorage.setItem('deviceRegistered', 'false');
      // this.messageService.errroMessage(
      //   '🚫 Failed to initialize Twilio Device',
      //   true,
      // );
    }
  }

  async makeCall(
    params: Record<string, string> = {},
    // patientId?: string,
  ): Promise<Call | undefined> {
    if (!this.device) {
      console.error('⚠️ Twilio Device is not initialized');
      return undefined;
    }

    try {
      const call: Call = await this.device.connect({ params });

      call.on('accept', (func: any) => {
        console.log('✅ Call accepted', func);
        localStorage.setItem('callActive', 'true');
        //https://twilioapidev.carevance.solutions/api/GetConferenceId?patientId=6666
      });

      call.on('disconnect', () => {
        localStorage.setItem('callActive', 'false');
        console.log('📴 Call disconnected');
        this.device?.disconnectAll();
      });

      call.on('error', (err: any) => {
        localStorage.setItem('callActive', 'false');
        console.error('❗ Call error:', err);
      });

      return call;
    } catch (error) {
      console.error('🚫 Failed to make call:', error);
      return undefined;
    }
  }

  disconnectCall() {
    this.device?.disconnectAll();
    console.log('🔌 All calls disconnected');

    localStorage.setItem('callActive', 'false');
  }

  destroy() {
    this.device?.destroy();

    localStorage.setItem('callActive', 'false');
    console.log('🗑️ Twilio Device destroyed');
  }
}
